export default {
  LOGIN_CHECK: 'login_check',
  CHANGE_PASSWORD: 'change-password',
  TOKEN_CHECK: '2fa-check',
  ACCEPT_CONTRACT: 'accept-contract',
  UPDATE_USER: 'users',
  USER_CHANGE_PASSWORD: 'user-change-password',
}
